import { getAuth } from '../service/auth';

const getLanguageUrl = () => {
  const currentLocale = process.env.DEFAULTLOCALE || 'zh-HK';
  const [lang, country] = currentLocale.toLowerCase().split('-');
  return country === 'hk' && lang === 'en' ? `/${lang}` : '';
};

const redirectToLoginPageIfLoggedOut = () => {
  const isLoggedOut = !getAuth();

  if (process.env.BROWSER && isLoggedOut) {
    window.location.href = `${getLanguageUrl()}/login`;
  }
};

const redirectToOrderPageIfLoggedIn = () => {
  const isLoggedIn = getAuth();

  if (process.env.BROWSER && isLoggedIn) {
    window.location.href = `${getLanguageUrl()}/order`;
  }
};

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: ['/order', '/en/order'],
      load: () => {
        redirectToLoginPageIfLoggedOut();
        return import(/* webpackChunkName: 'order' */ './order');
      },
    },
    {
      path: ['/show', '/en/show'],
      load: () => {
        redirectToLoginPageIfLoggedOut();
        return import(/* webpackChunkName: 'show' */ './show');
      },
    },
    {
      path: ['/dashboard', '/en/dashboard'],
      load: () => {
        redirectToLoginPageIfLoggedOut();
        return import(/* webpackChunkName: 'dashboard' */ './dashboard');
      },
    },
    {
      path: ['/login', '/en/login'],
      load: () => {
        redirectToOrderPageIfLoggedIn();
        return import(/* webpackChunkName: 'login' */ '../login/login.route');
      },
    },
    {
      path: ['/signup', '/en/signup'],
      load: () => {
        redirectToOrderPageIfLoggedIn();
        return import(/* webpackChunkName: 'signup' */ '../signup/signup.route');
      },
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => {
        redirectToOrderPageIfLoggedIn();
        redirectToLoginPageIfLoggedOut();
        return import(/* webpackChunkName: 'not-found' */ './not-found')
      },
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    // route.title = `${route.title || 'Untitled Page'}`;
    // route.description = route.description || '';

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js